export default __webpack_public_path__ + "static/media/happy60plus_icon.781b46d1.png";